import * as io from "io-ts";
import { PayloadFieldsBaseResolver, PayloadResolver } from "../../../../core/decoders/Content.types";
import {
    MaybeAuthorFieldResolver,
    MaybeBumperMusicFieldResolver,
    MaybeDateFieldResolver,
    MaybeHtmlFieldResolver,
    MaybeLinkFieldResolver,
    MaybePlainFieldResolver,
    MaybeEmbedFieldResolver,
} from "../../../../core/decoders/ContentBlocks.types";

export const CoastShowPayloadFieldsResolver = io.intersection([
    PayloadFieldsBaseResolver,
    io.type({
        articles: MaybeHtmlFieldResolver,
        author: MaybeAuthorFieldResolver,
        books: MaybeHtmlFieldResolver,
        highlights: MaybePlainFieldResolver,
        episodes: MaybePlainFieldResolver,
        zype_episodes: MaybePlainFieldResolver,
        host_name: MaybePlainFieldResolver,
        bumper_music: MaybeBumperMusicFieldResolver,
        show_date: MaybeDateFieldResolver,
        videos: MaybeHtmlFieldResolver,
        websites: MaybeHtmlFieldResolver,
        guest: MaybeLinkFieldResolver,
        host: MaybeLinkFieldResolver,
    }),
]);
export type CoastShowPayloadFields = io.TypeOf<typeof CoastShowPayloadFieldsResolver>;

export const CoastShowPayloadResolver = io.intersection([
    PayloadResolver,
    io.type({
        fields: CoastShowPayloadFieldsResolver,
    }),
]);
export type CoastShowPayload = io.TypeOf<typeof CoastShowPayloadResolver>;

export const CoastGuestPayloadFieldsResolver = io.intersection([
    PayloadFieldsBaseResolver,
    io.type({
        cds: MaybeHtmlFieldResolver,
        websites: MaybeHtmlFieldResolver,
        books: MaybeHtmlFieldResolver,
        videos: MaybeHtmlFieldResolver,
    }),
]);
export type CoastGuestPayloadFields = io.TypeOf<typeof CoastGuestPayloadFieldsResolver>;

export const CoastGuestPayloadResolver = io.intersection([
    PayloadResolver,
    io.type({
        fields: CoastGuestPayloadFieldsResolver,
    }),
]);
export type CoastGuestPayload = io.TypeOf<typeof CoastGuestPayloadResolver>;

export const CoastArticlePayloadFieldsResolver = io.intersection([
    PayloadFieldsBaseResolver,
    io.partial({
        primary_video: MaybeEmbedFieldResolver,
    }),
]);
export type CoastArticlePayloadFields = io.TypeOf<typeof CoastGuestPayloadFieldsResolver>;

export const CoastArticlePayloadResolver = io.intersection([
    PayloadResolver,
    io.type({
        fields: CoastArticlePayloadFieldsResolver,
    }),
]);

export type CoastArticlePayload = io.TypeOf<typeof CoastArticlePayloadResolver>;
